<script lang="ts" setup>
defineProps({
  errorMessage: {
    type: String,
    default: null,
  },
  unstyled: {
    type: Boolean,
    default: false,
  },
})
</script>

<template>
  <div
    :class="[
      unstyled ? 'position-relative z-50' : 'validation-message',
    ]"
  >
    <p v-show="errorMessage" :class="unstyled ? 'position-absolute text-xs text-danger' : 'py-1 m-0'">
      {{ errorMessage }}
    </p>
  </div>
</template>
